"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSBackdrop = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = require("@emotion/react");
var baseCss = react_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n"])));
var BDSBackdrop = function (_a) {
    var handleClick = _a.handleClick, style = _a.style;
    return jsx_runtime_1.jsx("div", { className: "bg-backdrop", onClick: handleClick, style: style, css: [baseCss] }, void 0);
};
exports.BDSBackdrop = BDSBackdrop;
var templateObject_1;
